import { useQuery } from "@apollo/client";
import React from "react";
import { View } from "./View";
import { query } from "./query";
export var Movies = function (_a) {
    var channel = _a.channel;
    var _b = useQuery(query, {
        variables: { channel: channel },
    }), data = _b.data, error = _b.error;
    if (error ||
        !data ||
        !data.moviesOnProgramOverview ||
        !data.moviesOnProgramOverview.items ||
        data.moviesOnProgramOverview.items.length <= 0) {
        return null;
    }
    return React.createElement(View, { items: data.moviesOnProgramOverview.items });
};
